import {
  REQUEST_STARTED,
  REQUEST_COMPLETED,
  APP_ERROR,
  CLEAR_APP_ERROR,
  FAVORITES_FETCHED,
  SESSION_EXPIRED,
} from '../actions/Actions';

// This is our apps initial state
// Since the initial state should never change, it is wrapped in a function to prevent unintended modification.
const getInitialState = () => {
  return {
    appError: null,
    sessionExpired: false,
  };
};

function appReducer(state = getInitialState(), action) {
  switch (action.type) {
    case REQUEST_STARTED:
      return {
        ...state,
        isFetching: true,
      };
    case REQUEST_COMPLETED:
      return {
        ...state,
        isFetching: false,
      };
    case APP_ERROR:
      return {
        ...state,
        isFetching: false,
        appError: action.error,
      };
    case CLEAR_APP_ERROR:
      return {
        ...state,
        isFetching: false,
        appError: null,
      };
    case SESSION_EXPIRED:
      return {
        ...state,
        sessionExpired: true,
      };
    case FAVORITES_FETCHED:
      return {
        ...state,
        isFetching: false,
        favorites: action.favorites,
      };
    default:
      return state;
  }
}

export default appReducer;
